import NoAccess from '../../partials/NoAccess';

const OWN_ROUTE_PREFIX = '/api/v1/partner/sub-merchant/';

// Every own route answers a deactivated sub-merchant with this 403; the partner-side
// /sub-merchants/* routes never match the prefix, so a missing permission there is not misread.
export const isSubMerchantDeactivated = (error) =>
  error?.response?.status === 403 &&
  error.response.data?.message === 'Request not allowed' &&
  String(error.config?.url ?? '').startsWith(OWN_ROUTE_PREFIX);

const SubMerchantDeactivated = () => (
  <NoAccess title="Account deactivated" message="This account is deactivated. Contact your partner." />
);

export default SubMerchantDeactivated;
